import "./SelectableMonth.style.css";

import { Box, CircularProgress } from "@mui/material";
import React, { FC, useEffect, useMemo, useState } from "react";

import BookCalendarIcon from "../Icons/BookCalendarIcon";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { addMothsToDate } from "../../utils";
import { fromUnixToDateString } from "../../utils/unix-timestamp";

interface ISelectableMonthProps {
  date?: Date;
  onSelected?: (value: Date) => void;
  icon?: React.ElementType<any>;
  daysCheck?: any;
  currentDay?: any;
  fullMonthDaysList?: any;
  handleMonthChange? (newMonth: Date): void;
  loading?: boolean;
  dateElement?: any;

}

const createDisabledDatesMap = (fullMonthDaysList: any[]) => {
  const map = new Map();

  fullMonthDaysList?.forEach((item) => {
    if (item.disabled) {
      const key = `${item.label}-${item.month}`;

      map.set(key, true);
    }
  });

  return map;
};

const SelectableMonth: FC<ISelectableMonthProps> = ({ onSelected, icon, currentDay, fullMonthDaysList,
  handleMonthChange, loading, dateElement }) => {
  const disabledDatesMap = useMemo(() => createDisabledDatesMap(fullMonthDaysList), [fullMonthDaysList]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // to open the calendar when the current day is selected
  }, [open]);

  const handleSelectDate = (newValue: Date | null) => {
    if (newValue) {
      onSelected && onSelected(newValue);
    }
  };

  const isDisabledDate = (date: Date) => {
    const currentCalendarDate = date.getDate().toString().padStart(2, "0");

    const monthInLongFormat = date.toLocaleString("default", { month: "long" });

    const key = `${currentCalendarDate}-${monthInLongFormat}`;

    return disabledDatesMap.has(key);
  };

  const shouldDisableDate = (date: Date) => {
    const isDisabled = isDisabledDate(date);
    const isCurrentDay = date.getTime() === new Date(+currentDay * 1000).getTime();

    return isDisabled && !isCurrentDay;
  };

  return <>
    <DesktopDatePicker
      open={open}
      onClose={() => setOpen(false)}
      views={["day"]}
      minDate={new Date()}
      maxDate={addMothsToDate(new Date(), 5)}
      value={new Date(fromUnixToDateString(+currentDay, "GMT"))}
      shouldDisableDate={shouldDisableDate}
      onChange={() => { }}
      onAccept={handleSelectDate}
      onMonthChange={(newMonth)=>handleMonthChange && handleMonthChange(newMonth)}
      openTo="month"
      components={{
        OpenPickerIcon: icon?icon:BookCalendarIcon,
      }}
      disabled={loading}
      loading={loading}
      renderLoading={() => <div className="loader-overlay">
        <CircularProgress />
      </div>}
      renderInput={({ inputRef, inputProps, InputProps }) => (
        <div className="flex justify-between bg-white border
         border-taupe-50 rounded-lg py-2 px-3 text-sm cursor-pointer"
        onClick={() => setOpen(true)}>
          {dateElement}
          <Box className="flex items-center" id={"gv-selectable-month-date-picker"}>
            <input
              className="w-0 p-0 border-none bg-none"
              ref={inputRef}
              {...inputProps}
              readOnly
            />
            {InputProps?.endAdornment}
          </Box>
        </div>
      )}
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, (-100)],
            },
          },
        ],
      }}
    />
  </>;
};

export default SelectableMonth;
